import { createContext, useContext, useState } from "react";

import { UserType } from "types/UserType";

import { StateManagerType } from "./StateManagerType";

import { useRegistartion } from "./useRegistration";
import { useDietanamnez } from "./useDietanamnez";

import { getQueryVariable } from "../getQueryVariable";
import { Data, DataLite } from "types/Data";
import { DietanamnezChartItem } from "types/DietanamnezItem";

type StateManager = Omit<StateManagerType, "screen"> & {
  screen: StateManagerType["screen"] | "ERROR";
  isInitial: boolean;
  setIsInitial: (value: boolean) => void;
  isLoading: boolean;
  setIsLoading: (isLoading: boolean) => void;
  selftestData: Data;
  blob: Blob;
  dietanamnezChartItems: DietanamnezChartItem[];
  parsedSelftestData: DataLite;
  type: "DIETANAMNEZ" | "REGISTRATION";
  userType: UserType;
};

export const StateManagerContext = createContext<StateManager | undefined>(
  undefined
);

/* eslint-disable react-hooks/rules-of-hooks */

export const useStateManager = (): StateManager => {
  const context = useContext(StateManagerContext);

  if (context) {
    return context;
  }

  const userType =
    window.location.pathname === "/p" ? UserType.PRO : UserType.LITE;

  const tokenRegistration = getQueryVariable("r");
  const tokenDietanamnez = getQueryVariable("i");

  const [isInitial, setIsInitial] = useState<boolean>(true);
  const [isLoading, setIsLoading] = useState<boolean>(false);
  const [selftestData, setSelftestData] = useState<any>(null);
  const [blob, setBlob] = useState<Blob>(new Blob());
  const [dietanamnezChartItems, setDietanamnezChartItems] = useState<DietanamnezChartItem[]>([]);
  const [parsedSelftestData, setParsedSelftestData] = useState<DataLite>({} as DataLite);

  const data = tokenRegistration
    ? useRegistartion(tokenRegistration, userType, setIsLoading, setSelftestData, setDietanamnezChartItems, setBlob, setParsedSelftestData, isInitial)
    : useDietanamnez(tokenDietanamnez!, userType);

  const screen = data.isError ? "ERROR" : data.screen;

  return {
    type: tokenRegistration
      ? ("REGISTRATION" as const)
      : ("DIETANAMNEZ" as const),
    isInitial,
    setIsInitial,
    isLoading,
    setIsLoading,
    selftestData,
    blob,
    dietanamnezChartItems,
    parsedSelftestData,
    userType,
    ...data,
    screen: data.linkInfo || data.isError ? screen : undefined,
    onNextScreen: async (exists = false) => {
      setIsInitial(false);
      await data.onNextScreen(exists);
    },
    onPrevScreen: () => {
      setIsInitial(false);
      data.onPrevScreen();
    },
  };
};
